import { useEffect, useRef, useState } from "react";

const ROUTE = "M 30 200 C 110 185 140 120 230 112 C 330 103 360 70 470 48";

export default function MapMock({ progress = 0.6, height = "h-56", dark = false, fromLabel = "Départ", toLabel = "Destination", testId = "map-mock" }) {
  const pathRef = useRef(null);
  const [pt, setPt] = useState({ x: 30, y: 200 });

  useEffect(() => {
    if (pathRef.current) {
      const len = pathRef.current.getTotalLength();
      setPt(pathRef.current.getPointAtLength(len * Math.min(1, Math.max(0, progress))));
    }
  }, [progress]);

  const bg = dark ? "#0B1F4D" : "#EAF4FF";
  const block = dark ? "rgba(185,220,255,0.07)" : "#DCEBFB";
  const street = dark ? "rgba(185,220,255,0.14)" : "#FFFFFF";

  return (
    <svg viewBox="0 0 500 240" className={`block w-full ${height}`} data-testid={testId} preserveAspectRatio="xMidYMid slice">
      <rect width="500" height="240" fill={bg} />
      {[
        [20, 24, 90, 56], [140, 16, 70, 70], [250, 30, 100, 48], [380, 20, 90, 60],
        [30, 120, 80, 60], [150, 130, 100, 44], [290, 120, 80, 70], [400, 130, 70, 50],
      ].map(([x, y, w, h], i) => (
        <rect key={i} x={x} y={y} width={w} height={h} rx={dark ? 4 : 0} fill={block} />
      ))}
      {[110, 215, 320, 425].map((x) => (
        <line key={x} x1={x} y1="0" x2={x} y2="240" stroke={street} strokeWidth="7" />
      ))}
      {[95, 185].map((y) => (
        <line key={y} x1="0" y1={y} x2="500" y2={y} stroke={street} strokeWidth="7" />
      ))}
      <path ref={pathRef} d={ROUTE} fill="none" stroke="#2457FF" strokeWidth="3.5" strokeLinecap="round" className="route-line" />
      <circle cx="30" cy="200" r="7" fill={dark ? "#B9DCFF" : "#0B1F4D"} stroke={dark ? "#0B1F4D" : "#fff"} strokeWidth="2.5" />
      <g transform="translate(470 48)">
        <circle r="13" fill="#2457FF" opacity="0.18" />
        <circle r="5.5" fill="#2457FF" stroke="#fff" strokeWidth="2" />
      </g>
      <g transform={`translate(${pt.x} ${pt.y})`}>
        <circle r="14" fill="#2457FF" opacity="0.18">
          <animate attributeName="r" values="10;18;10" dur="2.2s" repeatCount="indefinite" />
        </circle>
        <circle r="8" fill="#2457FF" stroke="#fff" strokeWidth="3" />
      </g>
      <text x="30" y="224" fontSize="10" fontFamily="JetBrains Mono, monospace" fill={dark ? "#B9DCFF" : "#667085"}>{fromLabel}</text>
      <text x="470" y="32" textAnchor="end" fontSize="10" fontFamily="JetBrains Mono, monospace" fill={dark ? "#B9DCFF" : "#667085"}>{toLabel}</text>
    </svg>
  );
}
